import { IWebCoreSettings } from '@lmnop/web-core';
import { BackgroundType } from './website-core-settings.class';

export interface IWebsiteCoreSettings extends IWebCoreSettings {
    backGroundType: BackgroundType;
}
